module.exports = __webpack_public_path__ + "static/img/8.ef492f1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/14/zh/8.png
// module id = so7F
// module chunks = 0